import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext({ lang: 'en', setLang: () => {}, toggleLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('site.lang') || 'en';
    } catch {
      return 'en';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('site.lang', lang);
    } catch {}
  }, [lang]);

  const toggleLang = () => setLang(prev => (prev === 'en' ? 'fr' : 'en'));

  const value = useMemo(() => ({ lang, setLang, toggleLang }), [lang]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext;
